import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "container popup__flex-box" }
const _hoisted_2 = {
  type: "submit",
  class: "payment-form__btn btns btns--largest btns--font-large btns--full"
}

import { ref } from 'vue'
import { useWait } from '@/app/composables/useWait'

import { BillingView } from '@/models/billing'
import { ValidationState } from '@/helpers/form'

import FormError from '@/components/ui/FormError.vue'
import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'
import StripeCard from '@/app/components/billing/StripeCard.vue'
import StripeCardInfo from '@/app/components/billing/StripeCardInfo.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CardEditPopup',
  props: {
    billing: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const wait = useWait()

const stripeCard = ref<InstanceType<typeof StripeCard> | null>(null)

const validation = ref(new ValidationState())
const visible = ref(false)

function show(): void {
  props.billing.cardEditMode = true
  visible.value = true
}

function hide(): void {
  props.billing.cardEditMode = false
  visible.value = false
}

async function submitForm(event: Event): Promise<void> {
  event.preventDefault()
  await subscribe()
}

async function subscribe(): Promise<void> {
  try {
    wait.start('Saving')
    let hideDialog: boolean = true
    if (props.billing.cardEditMode && stripeCard.value?.needsSaving()) {
      const result = await stripeCard.value?.save()
      if (result !== true) {
        hideDialog = false
      }
    }
    if (hideDialog) {
      hide()
    }
    wait.end('Saving')
  } catch (error) {
    wait.end('Saving')
    validation.value.showErrors(error)
  }
}

__expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  const _component_v_wait = _resolveComponent("v-wait")!
  const _directive_wait = _resolveDirective("wait")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "popup v-fade",
    onClick: hide
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "popup__content",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($event.stopPropagation()))
      }, [
        _createElementVNode("div", { class: "popup__close" }, [
          _createElementVNode("a", { onClick: hide }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "popup__close-icon iconfont iclose" }, null, -1)
          ]))])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "popup__title-box" }, [
          _createElementVNode("h2", { class: "popup__title" }, "Edit your credit card"),
          _createElementVNode("p", { class: "popup__text" }, " If you want to update your credit card used for your subscription, please do it below. ")
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("form", {
            class: "payment-form",
            onSubmit: submitForm
          }, [
            (visible.value && __props.billing.cardEditMode)
              ? (_openBlock(), _createBlock(StripeCard, {
                  key: 0,
                  ref_key: "stripeCard",
                  ref: stripeCard,
                  billing: __props.billing,
                  "show-button": false
                }, null, 8, ["billing"]))
              : (_openBlock(), _createBlock(StripeCardInfo, {
                  key: 1,
                  ref: "stripeCardInfo",
                  billing: __props.billing
                }, null, 8, ["billing"])),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_2, [
              _createVNode(_component_v_wait, { for: "Saving" }, {
                waiting: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createTextVNode(" Saving ", -1)),
                  _createVNode(ButtonSpinner)
                ]),
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createElementVNode("span", null, "Save", -1))
                ]),
                _: 1
              })
            ])), [
              [_directive_wait, 'Saving', "disabled"]
            ]),
            _createVNode(FormError, {
              errors: validation.value.errors,
              field: __props.billing.plan.id
            }, null, 8, ["errors", "field"])
          ], 32)
        ])
      ])
    ])
  ], 512)), [
    [_vShow, visible.value]
  ])
}
}

})